import { List, Button, Tag, Input, Select, Switch } from 'antd'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import './RelationConfig.scss'

RelationThroughRules = ({ value = [{ type: 'relation', key: 'type', to: 'Thing' }], onChange }) ->

  setRuleProp = (i, key, val) ->
    value[i][key] = val
    onChange(value)

  <div style={{ paddingBottom: 20 }} className="relation-rules">
    <List
      bordered
      dataSource={value}
      locale={{ emptyText: 'No rules' }}
      renderItem={(item, i) -> (
        <List.Item
          actions={[
            <Input
              placeholder="Key"
              style={{ display: 'inline' }}
              value={item.key}
              onChange={({ target: { value }}) -> setRuleProp(i, 'key', value)}
            />,
            <Input
              placeholder={item.type is 'relation' && 'Target' || 'Value'}
              style={{ display: 'inline' }}
              value={item.to or item.value}
              onChange={({ target: { value }}) -> setRuleProp(i, item.type is 'relation' && 'to' || 'value', value)}
            />
            <Button
              onClick={ ->
                value.splice(i, 1)
                onChange(value)
              }
              icon={<CloseOutlined />}
              type='link'
              danger
            />
          ]}
        >
          <Switch
            checkedChildren="Relation"
            unCheckedChildren="Attribute"
            checked={item.type is 'relation'}
            onChange={(val) -> setRuleProp(i, 'type', val && 'relation' || 'attribute')}
          />
        </List.Item>
      )}
    />
    <Button
      type="link"
      style={{ float: 'right', margin: '10px 0' }}
      icon={<PlusOutlined />}
      onClick={ -> onChange([value..., { type: 'relation' }])}
    >Add new rule</Button>
  </div>

export default RelationThroughRules